export const REVIEW_GENERATING_POLL_INTERVAL_MS = 1500

export const DEFAULT_REVIEW_SAFETY_POLL_INTERVAL_MS = 30_000

export function resolveReviewSafetyPollIntervalMs(
  env: Record<string, unknown> = import.meta.env as Record<string, unknown>,
): number {
  try {
    const raw = Number(env.VITE_REVIEW_SAFETY_POLL_MS)
    if (Number.isFinite(raw) && raw > 0)
      return raw
    return DEFAULT_REVIEW_SAFETY_POLL_INTERVAL_MS
  }
  catch {
    return DEFAULT_REVIEW_SAFETY_POLL_INTERVAL_MS
  }
}

export const REVIEW_SAFETY_POLL_INTERVAL_MS = resolveReviewSafetyPollIntervalMs()

export function resolveReviewStreamEnabled(
  env: Record<string, unknown> = import.meta.env as Record<string, unknown>,
): boolean {
  try {
    return env.VITE_REVIEW_STREAM_ENABLED !== 'false'
  }
  catch {
    return true
  }
}

export const REVIEW_STREAM_ENABLED = resolveReviewStreamEnabled()

export interface ReviewPollingState {
  generating: boolean
  streaming?: boolean
}

export function resolveReviewPollInterval(
  state: ReviewPollingState,
): number | false {
  if (!state.generating)
    return false
  if (state.streaming)
    return REVIEW_SAFETY_POLL_INTERVAL_MS
  return REVIEW_GENERATING_POLL_INTERVAL_MS
}

export function hasPendingAssistantTurn(
  messages: ReadonlyArray<{ role?: unknown, status?: unknown }> | undefined,
): boolean {
  return (
    messages?.some(
      message => message.role === 'assistant' && message.status === 'pending',
    ) ?? false
  )
}

export function reviewRefetchInterval(
  query: { state?: { data?: unknown } },
  streaming = false,
): number | false {
  const data = query?.state?.data as
    | ReadonlyArray<{ role?: unknown, status?: unknown }>
    | undefined
  return resolveReviewPollInterval({
    generating: hasPendingAssistantTurn(data),
    streaming,
  })
}
